import { FC } from 'react'

export const BmwHeaderLogo: FC = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <g clipPath="url(#clip0_1054_18931)">
      <path
        d="M22 0C9.85007 0 0 9.85007 0 22C0 34.1499 9.85007 44 22 44C34.1499 44 44 34.1499 44 22C44 9.85007 34.1499 0 22 0ZM42.5694 22C42.5694 33.3596 33.3609 42.5694 22 42.5694C10.6391 42.5694 1.43062 33.3596 1.43062 22C1.43062 10.6404 10.6404 1.43062 22 1.43062C33.3596 1.43062 42.5694 10.6404 42.5694 22Z"
        fill="#6F6F6F"
      />
      <path
        d="M21.9995 8.95361V9.66892C28.7981 9.66892 34.3305 15.2 34.3305 21.9999H35.0458C35.0458 14.7951 29.2043 8.95361 21.9995 8.95361ZM21.9995 34.331C15.2008 34.331 9.66844 28.7999 9.66844 21.9999H8.95312C8.95312 29.2048 14.7946 35.0463 21.9995 35.0463"
        fill="#6F6F6F"
      />
      <path
        d="M32.6621 12.6661C32.9609 12.9869 33.3916 13.5043 33.6335 13.8186L38.0884 10.991C37.8156 10.6363 37.5348 10.2878 37.2463 9.94584L34.4251 11.8111L34.2324 11.9766L34.376 11.7671L35.6216 9.28097L34.7408 8.40009L32.2533 9.64574L32.0438 9.78932L32.2107 9.59659L34.0772 6.77674C33.7486 6.49734 33.433 6.24123 33.0307 5.93079L30.2031 10.3818C30.5614 10.6573 31.0336 11.0621 31.3349 11.3377L33.997 9.95619L34.1677 9.83072L34.0423 10.0015L32.6621 12.6661Z"
        fill="#6F6F6F"
      />
      <path
        d="M22.5542 7.02507L23.7714 4.29835L23.849 4.05646L23.827 4.3087L23.955 7.95251C24.3819 7.99261 24.823 8.05211 25.2576 8.12455L25.0597 2.72803C24.4517 2.66077 23.8464 2.61291 23.241 2.58704L22.0419 5.5634L21.9992 5.78459L21.9566 5.5634L20.7588 2.58704C20.1534 2.61291 19.548 2.66077 18.9401 2.72803L18.7422 8.12455C19.1768 8.05211 19.6179 7.9939 20.0448 7.95251L20.1728 4.3087L20.1508 4.05646L20.2284 4.29835L21.4456 7.02507H22.5542Z"
        fill="#6F6F6F"
      />
      <path
        d="M12.7091 11.326C13.4127 10.5848 13.8111 9.72848 13.1075 8.91098C12.7246 8.46731 12.0817 8.37029 11.5488 8.5889L11.4958 8.60959L11.5126 8.56303C11.5915 8.35218 11.6419 7.67956 11.0689 7.21519C10.7895 6.98883 10.439 6.90475 10.0845 6.94097C9.42355 7.00823 8.9152 7.45966 7.53115 9.00282C7.11334 9.46848 6.50539 10.2032 6.14062 10.6792L9.94225 14.2855C11.2021 12.8911 11.7156 12.3724 12.7091 11.326ZM7.74846 10.4438C8.51421 9.50729 9.32783 8.65745 9.69648 8.32114C9.8129 8.21507 9.93966 8.109 10.0936 8.06761C10.3432 7.99906 10.6006 8.17627 10.6589 8.43238C10.7171 8.68979 10.5554 8.93426 10.3756 9.13605C9.9707 9.59266 8.48576 11.1462 8.48576 11.1462L7.74846 10.4438ZM9.23729 11.8563C9.23729 11.8563 10.6834 10.3274 11.1556 9.83843C11.3431 9.6444 11.4634 9.52669 11.5928 9.46331C11.7596 9.38182 11.942 9.365 12.105 9.47366C12.2654 9.58102 12.3391 9.76599 12.299 9.94967C12.2512 10.1683 12.0727 10.3765 11.9252 10.5356C11.726 10.7491 10.0108 12.5845 10.0082 12.5871L9.23729 11.8563Z"
        fill="#6F6F6F"
      />
      <path
        d="M21.9995 8.95361V21.9999H8.95312C8.95312 14.7899 14.7894 8.95361 21.9995 8.95361ZM35.0458 21.9999C35.0458 29.21 29.2095 35.0463 21.9995 35.0463V21.9999H35.0458Z"
        fill="#0066B1"
      />
    </g>
    <defs>
      <clipPath id="clip0_1054_18931">
        <rect width="44" height="44" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
